import React from 'react';
import { ProfileImage } from 'new/elements/ProfileImage';
import Typography from '@mui/material/Typography';
import styles from './TeamsTable.module.scss';
import { Team } from 'new/entities/Team';
import { useSelector } from 'react-redux';

export function Company(props: Team) {
  // @ts-ignore
  const orgs = useSelector((state) => state?.entities.orgs);
  const org = orgs[props.org];
  return (
    <div className={styles.companyContainer}>
      <ProfileImage size="small" fullName={org.name} />
      <Typography style={{ textAlign: 'center' }} variant="tdValue">
        {org.name}
      </Typography>
    </div>
  );
}
